// 注意:SSR 项目里走 asyncData 预取的路由不要用懒加载。
// getMatchedComponents() 对动态 import 返回未解析的工厂函数,
// asyncData 在工厂函数上找不到,SSR 阶段不会执行预取。
import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);

/* 路由配置 */
import NotFound from "../views/NotFound/index.vue";
import Fill_Home from "../views/fill/fill_home.vue";
import Fill_index from "../views/fill/fill_index.vue";
import Fill_article from "../views/detail/fill_article.vue";

/* 只在 Vue 2 环境中执行 */
if (VueRouter.prototype) {
  const originalPush = VueRouter.prototype.push;
  VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch((err) => err);
  };
}

const routes = [
  {
    path: "/",
    name: "fill_home",
    component: Fill_Home,
    meta: {
      title: "",
      description: "",
      keywords: "",
      status: 200,
    },
  },
  {
    path: "/about",
    name: "fill_index",
    component: Fill_index,
    meta: {
      title: "",
      description: "",
      keywords: "",
      status: 200,
    },
  },
  {
    path: "/school/article",
    name: "fill_article",
    component: Fill_article,
    meta: {
      title: "文章详情 - 高考早知道",
      description: "高考早知道文章详情页,提供最新招考公告、院校介绍、历年分数等资讯。",
      keywords: "文章详情,高考资讯,招考公告,院校介绍",
      status: 200,
    },
  },
  {
    // 外链跳转:Vue Router 的 redirect 只能跳内部路由,外链用 meta.redirect_url
    // 客户端:beforeEnter 里 window.location.href 跳转
    // SSR:entry.server.js 读 meta.redirect_url,server 返回 302 重定向
    path: "/h5",
    name: "redirect_h5",
    component: NotFound,
    beforeEnter(to, from, next) {
      if (typeof window !== 'undefined' && to.meta.redirect_url) {
        window.location.replace(to.meta.redirect_url);
        next(false); // 阻止导航,不渲染 NotFound,等浏览器跳转
      } else {
        next();
      }
    },
    meta: {
      title: "跳转中...",
      status: 301,
      redirect_url: `${process.env.VUE_APP_OUT_URL}/h5`,
    },
  },
  {
    path: "/miniform",
    name: "redirect_miniform",
    component: NotFound,
    beforeEnter(to, from, next) {
      if (typeof window !== 'undefined' && to.meta.redirect_url) {
        window.location.replace(to.meta.redirect_url);
        next(false); // 阻止导航,不渲染 NotFound,等浏览器跳转
      } else {
        next();
      }
    },
    meta: {
      title: "跳转中...",
      status: 301,
      redirect_url: `${process.env.VUE_APP_OUT_URL}/miniform`,
    },
  },
  {
    path: "*",
    name: "not-found",
    component: NotFound,
    meta: {
      title: "页面未找到 - 404",
      description: "您访问的页面不存在。",
      keywords: "404,页面未找到",
      status: 404,
    },
  },
];

const createRouter = () => {
  const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
    scrollBehavior(to, from, savePosition) {
      if (savePosition) {
        //解决页面从列表页跳转到详情页返回,初始在原来位置
        return savePosition;
      } else {
        //解决页面跳转后页面高度和前一个页面高度一样
        return { x: 0, y: 0 };
      }
    },
  });

  return router;
};

export default createRouter;
